<template>
  <div class="tab__header">
    <div class="select-all">
      <CustomCheckbox
        :color="isIndeterminate ? 'pink' : 'cold-marine'"
        :value="urlCount > 0"
        :indeterminate="isIndeterminate"
        size="s"
        @input="$emit('select-all')"
      />
      <div class="select-all__label">
        {{ `${urlCount} ${selectAllLabel}` }}
      </div>
      <div class='apply-selected-container' v-if='tab === "domains" || tab === "accounts"' :class='{visible: selectedItems.length > 0 || allSelected}'>
        <v-btn class="apply-selected-btn" :class='{accounts: tab === "accounts"}' @click="applySelected">
          {{$t('configuration.apply.selected')}}
        </v-btn>
      </div>
    </div>
    <div class="control" v-if="showControl">
      <!-- bugfix/CYN-1408-remove-additional-add-domain-bu -->
      <!--      <test-selector v-model="selectedTestOption"-->
      <!--      v-if="testOptions && testOptions.length"-->
      <!--      :test-options="testOptions"-->
      <!--      :disable-btn="!selectedTestOption || urlCount === 0"-->
      <!--      @submit="initiateTest"-->
      <!--      />-->
      <slot name="additional-buttons" />
    </div>
    <YesNoPopup
      :title='titleForPopup'
      :visible-popup='showInitiatedTestCardsPopup'
      yes-caption='test.cards.initiated.ok'
      :showNoButton='false'
      @clicked='onPopupClickOk'
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import YesNoPopup from '@/components/popup/YesNoPopup.vue';
import CustomCheckbox from '@/components/common/CustomCheckbox.vue';
import { CONFIGURATION } from '@/constants/configuration';
import { SET_DOMAIN_FILTER } from '@/store/filters/actionTypes';
// bugfix/CYN-1408-remove-additional-add-domain-bu
// import store from '@/store';
// import {
//   INITIATE_TEST_CARD,
// } from '@/store/project/actionTypes';
// import { ALL_TEST_CARD_TYPES, TEST_TYPES_TLDS } from '@/constants/projects';
// import TestSelector from './TestSelector.vue';

export default {
  name: 'ConfigurationItemHeader',
  components: {
    YesNoPopup,
    // bugfix/CYN-1408-remove-additional-add-domain-bu
    // TestSelector,
    CustomCheckbox,
  },
  props: {
    tab: {},
    assets: {
      type: Array,
      required: false,
      default: () => [],
    },
    selectedItems: {
      type: Array,
      default: () => ([]),
    },
    excludedItems: {
      type: Array,
      default: () => ([]),
    },
    testOptions: {},
    urlCount: {},
    selectAllLabel: {
      type: String,
      required: true,
    },
    showControl: {
      type: Boolean,
      default: () => true,
    },
    allItemsCount: {
      type: Number,
      default: () => 0,
    },
    allSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    tab() {
      this.selectedTestOption = '';
    },
  },
  data() {
    return {
      selectedTestOption: '',
      showInitiatedTestCardsPopup: false,
      initiateTestsFailed: false,
    };
  },
  computed: {
    ...mapGetters([
      'testCardsSubdomains',
      'testCardsHosts',
      'testCardsDomains',
      'domainFilter',
      'organizationFilter',
      'domainsPerOrganization',
      'cloudAccountsPerOrganization',
      'domains',
      'topLevelDomainsOptions',
    ]),
    titleForPopup() {
      return this.initiateTestsFailed ? 'initiate.test.cards.failed' : 'initiate.test.cards.successful';
    },
    isIndeterminate() {
      return this.allItemsCount !== this.urlCount;
    },
    testCards() {
      if (this.tab === CONFIGURATION.TAB.subdomains) {
        return { ...this.testCardsSubdomains, ...this.testCardsHosts } || [];
      }
      if (this.tab === CONFIGURATION.TAB.hosts) {
        return this.testCardsHosts || [];
      }
      if (this.tab === CONFIGURATION.TAB.domains) {
        return this.testCardsDomains || [];
      }
      return [];
    },
    cloudAccountOptions() {
      let items = [];
      if (this.organizationFilter) {
        this.organizationFilter.forEach(org => {
          items = items.concat([...(this.cloudAccountsPerOrganization.get(org) || [])].map(item => ({value: item, type: 'cloud', organization: org })));
        });
      } else {
        items = [...new Set([...this.domains])]; // DEFAULT COMPANY DOMAIN
      }
      return [...new Set(items)];
    },
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    onPopupClickOk(value) {
      this.showInitiatedTestCardsPopup = false;
    },
    // bugfix/CYN-1408-remove-additional-add-domain-bu
    // async initiateTest() {
    //   let hosts = [];
    //   if (this.tab === CONFIGURATION.TAB.subdomains) {
    //     this.selectedItems.forEach(item => {
    //       if (this.assets.some(asset => asset.subdomain === item)) {
    //         const fullAsset = this.assets.get(item);
    //         if (fullAsset.hosts) {
    //           hosts = hosts.concat(fullAsset.hosts.map(host => host.configData));
    //         }
    //       }
    //     });
    //   }
    //   const testCardIdList = [];
    //   const allAssetsSelected = this.selectedItems.concat(hosts);
    //   for (let index = 0; index < allAssetsSelected.length; index += 1) {
    //     const currentWebsite = allAssetsSelected[index];
    //     const testCardsForWebsite = this.testCards[currentWebsite];
    //     if (this.testCards[currentWebsite]) {
    //       testCardsForWebsite.forEach(testCard => {
    //         if (this.selectedTestOption === TEST_TYPES_TLDS.dataleaks) {
    //           if ([ALL_TEST_CARD_TYPES.dataleaks, ALL_TEST_CARD_TYPES.dataleaksGithub, ALL_TEST_CARD_TYPES.dataleaksPastebin].includes(testCard.type)) {
    //             testCardIdList.push(testCard.id);
    //           }
    //         } else if (testCard.type === this.selectedTestOption && testCard.status === 'created') {
    //           testCardIdList.push(testCard.id);
    //         }
    //       });
    //     }
    //   }
    //   try {
    //     await store.dispatch(INITIATE_TEST_CARD, testCardIdList);
    //   } catch (e) {
    //     this.initiateTestsFailed = true;
    //   } finally {
    //     this.showInitiatedTestCardsPopup = true;
    //   }
    // },
    async applySelected() {
      if (this.selectedItems.length) {
        await this.$store.dispatch(SET_DOMAIN_FILTER, this.selectedItems);
      } else if (this.allSelected) {
        let selectedItems = [];
        if (this.tab === 'domains') {
          selectedItems = this.topLevelDomainsOptions.filter(item => !this.excludedItems.includes(item.value)).map(domain => domain.value);
        } else if (this.tab === 'accounts') {
          selectedItems = this.cloudAccountOptions.filter(item => !this.excludedItems.includes(item.value)).map(domain => domain.value);
        }
        await this.$store.dispatch(SET_DOMAIN_FILTER, selectedItems);
      }
      await this.$emit('clearSelected');
      await this.$emit('apply');
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/design-system';

.tab__header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: $space-4;

  .select-all {
    display: flex;
    height: rem(35);
    padding-top: $space-2;

    &__label {
      color: var(--text-muted);
      font-family: $default-application-font-regular;
      font-size: $font-size-base;
      letter-spacing: 0;
      line-height: $space-5;
    }
  }

  .control {
    display: flex;

    .add-asset {
      // Triple selector for specificity without !important
      .add-subdomain-btn.add-subdomain-btn.add-subdomain-btn {
        background-color: var(--text-secondary) !important;
        color: var(--text-inverse) !important;
        font-family: $default-application-font-medium;
        font-size: $font-size-sm;
        height: $space-8;
        letter-spacing: 1.1px;
        line-height: $space-4;
        margin-right: $space-6;
        width: rem(143);
      }
    }

    .initiate-test-btn,
    .add-url-btn {
      &.initiate-test-btn {
        background-color: #11BA7F;
      }

      &.add-url-btn {
        background-color: var(--text-secondary);
        margin-right: 0;
      }

      border-radius: $radius-sm;
      box-shadow: $shadow-sm;
      color: var(--text-inverse);
      font-family: $default-application-font-medium;
      font-size: $font-size-sm;
      letter-spacing: 1.1px;
      line-height: $space-4;
      margin-right: $space-6;
    }
  }

  .apply-selected-container {
    margin-top: -$space-1;
    display: none;

    &.visible {
      display: flex;
    }
  }

  .apply-selected-btn {
    background-color: var(--brand-primary);
    font-size: $font-size-sm;
    color: $white;
    font-family: $default-application-font-medium;
    margin-left: $space-6;
  }
}
</style>
